import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SystemPanelIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 2.25H1C0.59 2.25 0.25 2.59 0.25 3V21C0.25 21.41 0.59 21.75 1 21.75H23C23.41 21.75 23.75 21.41 23.75 21V3C23.75 2.59 23.41 2.25 23 2.25ZM22.25 11.5H9.75V3.75H22.25V11.5ZM1.75 3.75H8.75V20.25H1.75V3.75ZM9.75 20.25V12.5H22.25V20.25H9.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SystemPanelIcon.displayName = 'SystemPanelIcon';
